import { systemCode } from '@root/package.json';

/** 角色归属 */
export enum ROLE_TYPE_ENUM {
  /** 外部 */
  OUTER = '1000',
  /** 内部 */
  INNER = '2000',
}

/** fashion系统编码 */
export const CURRENT_CLIENT_CODE = systemCode;
// eslint-disable-next-line vue/max-len
export const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDayetcFoOypFK8WJzHwGlPti3ZwIC8teMQyh3ZHhJupjDuUcdwS3ayX8cjsQjKaVwddQpDm6cOXlUWd80XqqDvpURiolMalyr/Vfm/v0sjMjSbnkEpwcaENlUvMYJBbE07MdoYftgzQ7H1DTiPpHDItL33r0XTTPn4pKxDXxsC5QIDAQAB';

/** SSO系统编码 */
export const SSO_SYSTEM_CODE = 'TG_FASHION_DESIGN';

/*
 * SSO url 返回授权code 字段名称
 * */
export const SSO_AUTHORIZATION_CODE = 'code';

/**
 * 外部系统跳转携带 token 和 tenantId
 */
export const SSO_TOKEN = 'ssoToken';
export const TENANT_ID = 'tenantId';

/**
 * yes / no
 */
export enum YES_NO_ENUM {
  YES = '1',
  NO = '0',
}

export enum YES_NO_NUMBER_ENUM {
  YES = 1,
  NO = 0,
}

export enum YES_NO_STRING_ENUM {
  YES = 'YES',
  NO = 'NO',
}

/** 供应商状态 */
export enum SUPPLIER_STATUS_ENUM {
  /** 待提交 */
  WAIT_SUBMIT = 0,
  /** 待实地验厂 */
  WAIT_FACTORY_INSPECTION = 2,
  /** 验厂评估中 */
  INSPECTION_REVIEW = 3,
  /** 待评级 */
  WAIT_GRADING = 4,
  /** 合作中 */
  COOPERATING = 5,
  /** 已淘汰（定级为D则进入已淘汰） */
  ELIMINATED = 6,
  /** 未验厂取消（草稿/待提交/待实地验厂阶段取消） */
  UNFACTORY_CANCEL = 7,
  /** 验厂资料驳回（审核后退回修改资料） */
  INSPECTION_PROFILE_REJECTED = 8,
}

export const YES_NO_LIST = [
  { value: YES_NO_ENUM.YES, label: '是' },
  { value: YES_NO_ENUM.NO, label: '否' },
];

export const YES_NO_NUMBER_LIST = [
  { value: YES_NO_NUMBER_ENUM.YES, label: '是' },
  { value: YES_NO_NUMBER_ENUM.NO, label: '否' },
];

export const ENABLE_DISABLE_LIST = [
  { value: YES_NO_ENUM.YES, label: '启用' },
  { value: YES_NO_ENUM.NO, label: '禁用' },
];
export const ENABLE_DISABLE_COLOR_LIST = [
  { value: YES_NO_ENUM.YES, label: '启用', color: 'success' },
  { value: YES_NO_ENUM.NO, label: '禁用', color: 'danger' },
];
export const ENABLE_DISABLE_NUMBER_LIST = [
  { value: YES_NO_NUMBER_ENUM.YES, label: '启用', color: 'success' },
  { value: YES_NO_NUMBER_ENUM.NO, label: '禁用', color: 'danger' },
];

export const ENABLE_DISABLE_REVERT_LIST = [
  { value: YES_NO_ENUM.YES, label: '禁用' },
  { value: YES_NO_ENUM.NO, label: '启用' },
];

export const OPEN_CLOSE_LIST = [
  { value: YES_NO_ENUM.YES, label: '已开通' },
  { value: YES_NO_ENUM.NO, label: '未开通' },
];

// 排序枚举
export enum SORT_ORDER_ENUM {
  ASC = 'asc',
  DESC = 'desc'
}
/**
 * 排序方式枚举 枚举备注: ASC :升序 DESC :降序
 */
export enum SORT_ENUM {
  /** ASC :升序 */
  ASC = 'ASC',
  /**  DESC :降序 */
  DESC = 'DESC',
}
/** 大写字母的排序 */
export const UPPER_CASE_SORT_STRING_LIST = [
  { value: SORT_ENUM.ASC, label: '升序' },
  { value: SORT_ENUM.DESC, label: '降序' },
];
